import React, { useState, useEffect } from "react";

// Carousel components (used for days and times)
const CarouselSelector = (props) => {
    const {isWAResident, isMember, selectedDay, selectedTime} = props;
    const [scrollPosition, setScrollPosition] = useState('start');
    const [maxVisible, setMaxVisible] = useState(null);

    // click to scroll the carousel nav
    const scrollCarousel = (e) => {
        const carousel = e.target.closest('.carousel-selector').querySelector('.carousel-selector__carousel');

        // scroll the container
        let direction = e.target.getAttribute('direction');
        let scrollAmount = carousel.clientWidth;
        scrollAmount *= (direction === 'next') ? 1 : -1;
        carousel.scrollLeft += scrollAmount;
    }

    // keep track of scroll position
    const trackScrollPosition = (e) => {
        if (e.target.scrollLeft === 0) {
            setScrollPosition('start');
        } else if (e.target.scrollLeft + e.target.clientWidth >= e.target.scrollWidth - 10) {
            setScrollPosition('end');
        } else {
            setScrollPosition('middle');
        }
    }

    // set the max number of visible items
    useEffect(() => {
        function handleMax() {
            if (window.innerWidth < 1024) { setMaxVisible(3) }
            else if (window.innerWidth < 1440) { setMaxVisible(5) }
            else { setMaxVisible(7) }
        }

        handleMax();
        window.addEventListener('resize', handleMax);

        return () => {
            window.removeEventListener('resize', handleMax);
        }
    }, []);

    // scroll to keep the selected day in view
    useEffect(() => {
        if (selectedDay && !selectedTime) {
            let highlightedDate = document.querySelector('.carousel-selector__day--selected');
            let dateCarousel = highlightedDate.closest('.carousel-selector__carousel');

            if (
                // farther to the right
                highlightedDate.offsetLeft > dateCarousel.clientWidth + dateCarousel.scrollLeft
                ||
                // farther to the left
                highlightedDate.offsetLeft + highlightedDate.clientWidth < dateCarousel.scrollLeft
            ) {
                dateCarousel.scrollLeft = highlightedDate.offsetLeft - highlightedDate.clientWidth - 4;
            }
        }
    }, [selectedDay]);

    return (
        <div className={`carousel-selector ${(isWAResident.isResident && isWAResident.isConfirmed) ? 'resident' : 'non-resident'} ${(isMember) ? 'member' : ''}`}>
            <ul className="carousel-selector__carousel" onScroll={(e) => trackScrollPosition(e)}>
                {props.children}
            </ul>
            <nav className="carousel-selector__nav">
                <button
                    className="carousel-selector__nav-button carousel-selector__nav-button--prev"
                    direction="prev"
                    disabled={(scrollPosition == 'start') || props.children.length <= maxVisible}
                    onClick={(e) => scrollCarousel(e)}
                >
                    <i className="icon icon-arrow"></i>
                    <span className="sr-only">Prev</span>
                </button>
                <button
                    className="carousel-selector__nav-button carousel-selector__nav-button--next"
                    direction="next"
                    disabled={(scrollPosition == 'end' || props.children.length <= maxVisible)}
                    onClick={(e) => scrollCarousel(e)}
                >
                    <i className="icon icon-arrow"></i>
                    <span className="sr-only">Next</span>
                </button>
            </nav>
        </div>
    );
}

export default CarouselSelector;